export default {
  home: "Home",
  aboutUs: "About Us",
  capabilities: "Capabilities",
  esg: "ESG",
  careers: "Careers",
  contact: "Contact",
  ourJourney: "Our Journey",
  visionMission: "Vision & Mission",
  leadershipTeam: "Leadership Team",
};

